import React, { useEffect, useState } from 'react';
import {playerRequests} from '../../request/requests';
import { getIdPlayer } from '../../utils/users';
import { useNavigate } from 'react-router-dom';

export default function Form() {
    const [pseudo, setPseudo] = useState('');
    const navigate = useNavigate();

    const submit = async () => {
        const res = await playerRequests.createPlayer({pseudo});
        if(res.success){
            navigate('/game');
        }else{
            alert(res.msg);
        }
    }

    useEffect(() => {
        if(getIdPlayer()){
            navigate('/game');
        }
    }, []);

    if(getIdPlayer()){
        return null;
    }
    
    return (
        <div style={{margin: 'auto', textAlign: 'center'}}>
            {/* Back Button */}
            <div 
                onClick={() => { window.history.back(); }}
                style={{
                    position: 'absolute',
                    top: '15px',
                    left: '15px',
                    width: '35px',
                    height: '35px',
                    borderRadius: '50%',
                    backgroundColor: '#fff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
                    cursor: 'pointer',
                    zIndex: 3000
                }}
                >
                <svg 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path 
                    d="M19 12H5M5 12L12 19M5 12L12 5" 
                    stroke="#004A7C" 
                    strokeWidth="2.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    />
                </svg>
            </div>
            <img alt="" width={'100%'} style={{position: 'relative', top: 0, left: 0}} src="./assets/header-welcome.png" />
            <div style={{background: '#FBB900', color: '#004A7C', padding: '8px', textAlign: 'center', fontSize: '0.9rem', fontWeight: '400', textTransform:"uppercase"}}>
                Welcome explorer!
            </div>
            <div style={{padding: '30px', height: '60vh',textAlign: 'center', position: 'relative', width: '100vw', background: 'linear-gradient(180deg, #FFF4AA 0%, #FFDB00 100%)'}}>
                <div style={{maxWidth: '100%', margin: '0 auto', fontWeight: '400', fontSize: '1rem',lineHeight:'1.3rem', color: '#004A7C'}}>
                    Embark on a CityTrip with HARIBO!<br />
                    Roll the dice, answer cool questions, and race up the global leaderboard to prove you're the ultimate HARIBO fan!<br />
                    The faster, the higher your score.
                </div>
                <a
                href="https://www.haribo.com/en-us/terms-of-use"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: 'relative',
                    fontFamily: 'VAG Rundschrift D',
                    fontStyle: 'normal',
                    fontWeight: 300,
                    fontSize: '12px',
                    textAlign: 'center',
                    textDecoration: 'underline',
                    color: '#004A7C',
                    display: 'block',
                    marginTop: '10px',
                    cursor: 'pointer',
                    zIndex: '3000'
                }}
                >
                    Read the Rules
                </a>
            </div>
            <div style={{width: '100%'}}>
                <img width="100%" alt="" src="./assets/illustre-1-form.png" style={{position: 'absolute', bottom: '20%', zIndex: 0, left: 0}} />
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100vh" viewBox="0 0 393 773" fill="none" style={{position: 'absolute', bottom: '-10vh', left: 0}}>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M-341.732 0H-344V880H736V0H733.732C708.582 274.773 477.434 489.988 196 489.988C-85.4337 489.988 -316.582 274.773 -341.732 0Z" fill="#118A9B"/>
                </svg>
                <div style={{
                    position: 'absolute',
                    bottom: '5%',
                    left: '10%',
                    width: '80%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    zIndex: 3000
                }}>
                    <input
                        className="input"
                        onChange={(e) => setPseudo(e.target.value)}
                        placeholder="Enter a nickname*"
                        value={pseudo}
                        style={{
                        border: 'none',
                        outline: 'none',
                        textAlign: 'center',
                        fontWeight: '400',
                        background: '#0C7789',
                        color: '#ffffff',
                        padding: '0.8em',
                        borderRadius: '2.6em',
                        textTransform: 'uppercase'
                        }}
                    />
                    <div
                        onClick={submit}
                        style={{
                        background: 'white',
                        fontWeight: '400',
                        fontSize: '1.2rem',
                        color: '#004A7C',
                        padding: '0.5em',
                        borderRadius: '2.6em',
                        textAlign: 'center'
                        }}
                    >
                        LET'S GO!
                    </div>
                </div>
            </div>
        </div>
    );
}